var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-content"},[_c('div',[_vm._v(" 技术支持："),_c('span',[_vm._v("郑州铭嘉智能科技有限公司")]),_vm._v(" "),_c('span',[_vm._v("15838190295")])])])
}]

export { render, staticRenderFns }